import {
  Component,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  FormControl
} from '@angular/forms';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/take';


export class SkySelectFieldDemoComponent implements OnInit {
  public reactiveForm: FormGroup;

  public colors = [
    { id: '1', label: 'Red' },
    { id: '2', label: 'Green' },
    { id: '3', label: 'Violet' }
  ];

  public fruits = [
    { id: '1', category: 'Pome', label: 'Apple', description: 'Anne eats apples' },
    { id: '2', category: 'Berry', label: 'Banana', description: 'Ben eats bananas' },
    { id: '3', category: 'Pome', label: 'Pear', description: 'Patty eats pears' },
    { id: '4', category: 'Berry', label: 'Grape', description: 'George eats grapes' },
    { id: '5', category: 'Berry', label: 'Banana', description: 'Becky eats bananas' },
    { id: '6', category: 'Citrus', label: 'Lemon', description: 'Larry eats lemons' },
    { id: '7', category: 'Aggregate fruit', label: 'Strawberry', description: 'Sally eats strawberries' }
  ];

  public fruitStream = new BehaviorSubject<any>([]);
  public colorStream = new BehaviorSubject<any>([]);

  public templateDrivenModel: any = {
    favoriteColor: this.colors[0],
    favoriteFruits: [this.fruits[0]]
  };

  constructor(
    private formBuilder: FormBuilder
  ) { }

  public ngOnInit(): void {
    this.createForm();
    this.populateData();
  }

  public submitReactiveForm(): void {
    alert('Form submitted with: \n' + JSON.stringify(this.reactiveForm.value));
  }

  public submitTemplateForm(formData: any): void {
    alert('Form submitted with: \n' + JSON.stringify(formData));
  }

  private createForm(): void {
    this.reactiveForm = this.formBuilder.group({
      favoriteColor: new FormControl(this.colors[0]),
      favoriteFruits: new FormControl([this.fruits[0]])
    });
  }

  private populateData() {
    this.fruitStream.next(this.fruits);
    this.colorStream.next(this.colors);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-select-field-demo',
  template: `<sky-row>
  <sky-column screenSmall="6">
    <h2 class="sky-section-heading">
      Reactive form setup
    </h2>

    <form
      [formGroup]="reactiveForm"
      (ngSubmit)="submitReactiveForm()"
      novalidate>

      <div class="sky-form-group">
        <label
          class="sky-control-label"
          id="my-select-field-1">
          What is your favorite color?
        </label>
        <sky-select-field
          [data]="colorStream"
          ariaLabelledBy="my-select-field-1"
          formControlName="favoriteColor"
          pickerHeading="Colors"
          selectMode="single"
          singleSelectClearButtonTitle="Clear selected color"
          singleSelectOpenButtonTitle="Select a color"
          singleSelectPlaceholderText="Select a color...">
        </sky-select-field>
      </div>

      <div class="sky-form-group">
        <label
          class="sky-control-label"
          id="my-select-field-2">
          What are your favorite fruits?
        </label>
        <sky-select-field
          [data]="fruitStream"
          ariaLabelledBy="my-select-field-2"
          formControlName="favoriteFruits"
          multipleSelectOpenButtonText="Select some fruits"
          pickerHeading="Fruits">
        </sky-select-field>
      </div>

      <div class="select-field-demo-alert">
        <strong>Form model:</strong>
        <pre>{{ reactiveForm.value | json }}</pre>
      </div>

      <button
        class="sky-btn sky-btn-primary"
        type="submit">
        Submit
      </button>
    </form>
  </sky-column>
  <sky-column screenSmall="6">
    <h2 class="sky-section-heading">
      Template-driven form setup
    </h2>

    <form
      #myForm="ngForm"
      (ngSubmit)="submitTemplateForm(myForm.value)"
      novalidate>

      <div class="sky-form-group">
        <label
          class="sky-control-label"
          id="my-select-field-template-driven-1">
          What is your favorite color?
        </label>
        <sky-select-field
          [data]="colorStream"
          ariaLabelledBy="my-select-field-template-driven-1"
          pickerHeading="Colors"
          selectMode="single"
          singleSelectClearButtonTitle="Clear selected color"
          singleSelectOpenButtonTitle="Select a color"
          singleSelectPlaceholderText="Select a color..."
          name="favoriteColor"
          [(ngModel)]="templateDrivenModel.favoriteColor">
        </sky-select-field>
      </div>

      <div class="sky-form-group">
        <label
          class="sky-control-label"
          id="my-select-field-template-driven-2">
          What are your favorite fruits?
        </label>
        <sky-select-field
          [data]="fruitStream"
          ariaLabelledBy="my-select-field-template-driven-2"
          multipleSelectOpenButtonText="Select some fruits"
          pickerHeading="Fruits"
          name="favoriteFruits"
          [(ngModel)]="templateDrivenModel.favoriteFruits">
        </sky-select-field>
      </div>

      <div class="select-field-demo-alert">
        <strong>Form model:</strong>
        <pre>{{ myForm.value | json }}</pre>
      </div>

      <button
        class="sky-btn sky-btn-primary"
        type="submit">
        Submit
      </button>
    </form>
  </sky-column>
</sky-row>
<sky-row>
  <sky-column screenSmall="12">
    <h2 class="sky-section-heading">
      Disabled select fields
    </h2>

    <div class="sky-form-group">
      <label
        class="sky-control-label">
        Make a single selection (disabled)
      </label>
      <sky-select-field
        [data]="colorStream"
        [disabled]="true"
        selectMode="single">
      </sky-select-field>
    </div>

    <div class="sky-form-group">
      <label
        class="sky-control-label">
        Make multiple selections (disabled)
      </label>
      <sky-select-field
        [data]="fruitStream"
        [disabled]="true">
      </sky-select-field>
    </div>
  </sky-column>
</sky-row>
`,
  styles: [`.select-field-demo-alert {
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #cdcfd2;
  border-radius: 3px;
}

.select-field-demo-alert pre {
  margin: 0;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
